import React, { useEffect, useRef } from "react";
import { debounce } from "./debounce";
import { isNotNullOrUndefined } from "./isNotNullOrUndefined";

function Observer({
  onVisible,
  children,
  index,
  intersectionRatio,
}: {
  onVisible: Function;
  children: any;
  index: number | string;
  intersectionRatio?: number;
}) {
  const ref = useRef(null);
  useEffect(() => {
    const current = ref.current;
    const observer = new IntersectionObserver(async ([entry]) => {
      console.log(entry.intersectionRatio);

      if (entry.isIntersecting) {
        if (onVisible) {
          if (onVisible !== undefined || onVisible !== null) {
            if (isNotNullOrUndefined(intersectionRatio)) {
              if (entry.intersectionRatio === intersectionRatio) {
                debounce(onVisible(index), 3000);
              }
            } else {
              debounce(onVisible(index), 3000);
            }
          }
        }

        observer.unobserve(ref.current!);
      }
    });

    observer.observe(ref.current!);

    return () => {
      observer.unobserve(current!);
    };
  }, [index, onVisible]);
  return (
    <div style={{ width: "100%" }} key={index} ref={ref}>
      {children}
    </div>
  );
}

export default Observer;
